import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { Title } from '../../utils/title';
import content from '../../utils/content';
import Layout from './Layout';
import styles from './EntryList.module.scss';

const EntryList = ({ title, contentType, image, link }) => {

  const [ loading, setLoading ] = useState(false);
  const [ items, setItems ] = useState([]);

  useEffect(() => {

    setLoading(true);

    const fetchData = contentType === 'blog'
      ? content.getBlogPosts()
      : content.getCaseStudies();

    fetchData
      .then(res => {
        setLoading(false);
        setItems(res.items);
      })
      .catch(err => {
        setLoading(false);
        setItems([]);
      });

  }, [contentType]);

  return (
    <>
      <Title value={title} />
      <Layout>
        <div className={styles.root}>

          <h1>{title}</h1>

          {
            loading && (
              <div className={styles.loading}>
                Loading...
              </div>
            )
          }

          {
            items.length > 0 && (
              <div className={styles.content}>
                {
                  items.map(item => (
                    <Link
                      key={item.slug}
                      className={styles.item}
                      aria-label={item.title}
                      to={link(item)}>

                      <div className={`
                        ${styles.image}
                        ${{
                          'cover': styles.cover,
                          'contain': styles.contain,
                        }[image.mode]}
                      `}>

                        <LazyLoadImage
                          src={item[image.field]}
                          alt={item[image.altField] || item.title}
                        />
                      </div>

                      <div className={styles.title}>
                        {item.title}
                      </div>

                      <div className={styles.date}>
                        {new Date(item.published_date).toLocaleDateString()}
                      </div>

                    </Link>
                  ))
                }
              </div>
            )
          }

        </div>
      </Layout>
    </>
  );
};

export default EntryList;